module.exports = __webpack_public_path__ + "media/2.3ac3647b.mp3";